<template>
    <section class="header_first_area" id="home">
            <div class="menu_area">
                <!-- container starts -->
                <div class="container">
                    <!-- row start -->
                    <div class="row">
                        <div class="col-md-2">
                            <div class="user_some">
                                <div class="user_some_box">
                                        <div>
                                            <i class="fa fa-user" aria-hidden="true"></i><a @click="logInOut">{{!isLoggedIn?'Belépés / regisztráció':'Kijelentkezés'}}</a> <span v-if="isLoggedIn" style="color:#fff">{{'('+$store.getters.getCurrentUser+')'}}</span>
                                        </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-7">
                            <div class="mainmenu">
                                <nav class="navbar">
                                    <div class="navbar-header">
                                        <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#for_mobile" aria-expanded="false">
                                            <i class="fa fa-bars"></i>
                                        </button>
                                    </div>
                                    <div class="collapse navbar-collapse" id="for_mobile">
                                        <ul class="nav navbar-nav">
                                            <li v-for="m in menus">
                                                <template v-if="m.link">
                                                    <a v-if="m.link.external" :href="m.link.url" target="_blank">{{m.name}}</a>
                                                    <router-link v-if="!m.link.external" :to="m.link.url" tag="a">{{m.name}}</router-link>
                                                </template>
                                                <a v-else>{{m.name}}</a>
                                            </li>
                                        </ul>
                                    </div>

                                </nav>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="estric">
                                <div class="estric_box">
                                    <ul>
                                        <li><router-link tag="a" to="/dashboard/profile"><span>Profil</span><i class="fa fa-user-o" aria-hidden="true"></i></router-link></li>
                                        <li><router-link tag="a" to="/dashboard/basket"><span>Kosaram ({{basketSize == 0?'üres':basketSize+' db'}})</span><i class="fa fa-shopping-basket" aria-hidden="true"></i></router-link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
</template>
<script>
import uuid from '@commons/util/Uuid.js'
import Endpoints from '@commons/communication/endpoints.js'

export default{
    mixins:[uuid,Endpoints],
    data:function () {
        return {
            menus:[]
        };
    },
    computed:{
        isLoggedIn:function () {
            return this.$store.getters.isLoggedIn
        },
        basketSize:function () {
            return this.$store.getters.getBasket.basketElements.length;
        }
    },
    created:function () {
        var self = this;
        this.connGetMenusTree('WEBSHOP_TOP',function (r) {
            self.menus = r.data.list;
        })
    },
    methods:{
        logInOut:function () {
            if (!this.isLoggedIn){
                this.$router.push('/login')
            }else{
                var self = this;
                this.connLogout(function () {
                    self.reInitStore();
                    self.$router.push('/');
                })
            }
        },
        reInitStore:function () {
            this.$store.commit('setLoggedIn',false)
            this.$store.commit('setCurrentUser',null);
            this.$store.commit('setCurrentToken',this.guid())
                this.$store.commit('setBasket',{
                    basketElements:[]
                });

                this.$store.commit('setWatched',{
                    list:[]
                });

        }
    }
}
</script>



// WEBPACK FOOTER //
// Header.vue?24d09024